<script>
  import { link } from 'svelte-spa-router';
  import active from 'svelte-spa-router/active';

  export let options = [];
</script>

<style type="text/scss">
  @import './styles/theme.scss';

  .tab-bar {
    justify-content: center;
    align-items: baseline;
    display: flex;
  }
  .tabs {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  .tab {
    color: $c-black;
    text-decoration: none;
    border: 1px solid $c-gray-4;
    border-right: none;
    display: inline-block;
    cursor: pointer;
    @include fluid-font-size($fs-base);
    @include fluid-space(padding-top padding-bottom, $sp-xsmall);
    @include fluid-space(padding-left padding-right, $sp-base);
    outline: none;
  }
  .tab:first-child {
    border-radius: 2px 0 0 2px;
  }
  .tab:last-child {
    border-radius: 0 2px 2px 0;
    border-right: 1px solid $c-gray-4;
  }
  :global(.tab:hover, .tab--active, .tab--active:hover) {
    background-color: $c-gray-5;
  }
</style>

<div class="tab-bar">
  <div class="tabs">
    {#each options as option}
      <a
        href={option.slug}
        class="tab"
        use:active={{ path: option.slug, className: 'tab--active' }}
        use:link>
        {option.name}
      </a>
    {/each}
  </div>
</div>
